<div class="card text-center">
    <div class="">
        <div class="row">
            <div class="col-md-2">
                <div class="form-group">
                    <label for="birthDate">{{'DAY' | translate}}</label>
                    <div class="input-group input-group-sm">
                        <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}" (change)="getDate()"
                            (navigate)="getDate()" [(ngModel)]="selectedDay" ngbDatepicker #d="ngbDatepicker">
                        <div class="input-group-addon" (click)="d.toggle()">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <sanabel-selectize appcode="1014" [(ngModel)]="docId"
                    [SearchKeys]="{SpecialityId:selectedPatAppointment.specialization}"
                    (clicked)="doctorClicked($event)">
                </sanabel-selectize>
            </div>
            <div class="col-md-7">
                <timeSlotPicker (currentSlot)="selectedCurrentSlot($event)" [listeningGuid]="listeningGuid">
                </timeSlotPicker>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <btns-ctrl [appCodes]="[1]" (clicked)="save()"></btns-ctrl>
                </div>
            </div>
        </div>
    </div>
</div>